import { Avatar as CXAvatar } from '@sanlamcx/react-ui-next-avatar';

type Avatar = typeof CXAvatar;
export const Avatar: Avatar = CXAvatar;
